import type { StyledComponentProps } from '@material-ui/core/styles';
import { functions } from 'helpers/functions';
import QueryString from 'query-string';
import React from 'react';
import { getActionFields } from 'store/Orbita/Connect/actions';

import type { DispatchProp } from 'react-redux';

interface IProps extends StyledComponentProps, DispatchProp<any> {
  currentAction: any;
  options: any;
  currentConnect: any;
  actionFields: any;
  onSave?: any;
  triggers: any;
  optionsAction: any;
  modal: any;
  handleClose?: any;
  newAction: any;
  step: any;
  fields: any;
  currentUser: any;
}

export default abstract class BaseAction extends React.Component<IProps, any> {
  getOptionsParametersShouldModify = (action: any, prevAction: any, options: any) => {
    const selectedOption = options && Array.isArray(options) && options.find((item: any) => item.id === action.option_id);

    const selectedOptionHasUpdated = prevAction.option_id !== action.option_id;

    if (!selectedOption) {
      return [];
    }

    if (selectedOptionHasUpdated) {
      return selectedOption.parameters.campos.map((item: any) => item.nome);
    }

    if (!action.options_parameters) {
      return [];
    }

    const keys = Object.keys(action.options_parameters);

    const modifiedParameters = keys.filter((item: any) => {
      return !functions.isEqual(action.options_parameters[item], prevAction.options_parameters[item]);
    });

    const result = modifiedParameters.reduce((accumulator: any, item: any) => {
      const dependents = this.getDependentsOf(item, selectedOption.parameters.campos);

      if (dependents.length <= 0) {
        return accumulator;
      }

      return accumulator.concat(dependents.map((dependent: any) => dependent.nome));
    }, []);

    return result;
  };

  dispatchNewOptionParam = async (autoResponderId: number, connectId: number, itemName: string, params: any) => {
    const keys = itemName.split('_');
    const toSearch = `${keys[0]}_${keys[1]}`;

    let paramsString = undefined;

    if (params && typeof params === 'object') {
      paramsString = QueryString.stringify(params);
    }

    await this.props.dispatch(getActionFields(autoResponderId, connectId, toSearch, paramsString));

    let newOption = { field: itemName, value: functions.cloneDeep(this.props.actionFields) };

    return this.props.dispatch({ type: 'ADD_NEW_OPTION_ACTION', newOption });
  };

  getOptionParametersQuery = (item: any, selectedOption: any, action: any) => {
    const toSearch = `pvo_${item.campo_carregar}`;
    const tags = item.nome.split('_');
    const dependentName = [tags[0] || '', item.campo_carregar, tags[2] || ''].filter((value) => value && value.length > 0).join('_');

    const dependentsWhoHaveDependents = selectedOption.parameters.campos.filter(
      (dependent: any) => dependent.nome === dependentName && dependent.campo_carregar
    );

    const result = dependentsWhoHaveDependents.reduce(
      (accumulator: object, dependent: any) => {
        const dependentToSearch = `pvo_${dependent.campo_carregar}`;
        const dependentTags = dependent.nome.split('_');

        const dependentDependentName = [dependentTags[0] || '', dependent.campo_carregar, dependentTags[2] || '']
          .filter((value) => value && value.length > 0)
          .join('_');

        accumulator[dependentToSearch] = action.options_parameters[dependentDependentName] ? action.options_parameters[dependentDependentName] : null;

        return accumulator;
      },
      {
        [toSearch]: action.options_parameters[dependentName] ? action.options_parameters[dependentName] : null,
      }
    );

    return result;
  };

  getDependentsOf = (key: string, fields: any) => {
    const keyTags = key.split('_');

    let dependents = fields.filter((field: any) => {
      const tags = field.nome.split('_');
      const fieldKey = [keyTags[0] || '', field.campo_carregar, keyTags[2] || ''].filter((value) => value && value.length > 0).join('_');

      return key === fieldKey && tags.length === keyTags.length;
    });

    return dependents.reduce((accumulator: any, dependent: any) => {
      return accumulator.concat(this.getDependentsOf(dependent.nome, fields));
    }, dependents);
  };
}
